import React, { useEffect } from "react";
import Footer from "../Footer";
import {
  SCMakePaymentContainer,
  SCPaymentContent,
  SCPaymentSection,
} from "../Payment/css";
import { Nav } from "../Nav";
import { handleRemediationBankAccountUpdate } from "../../actions/paymentActions";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import AddBankDetails from "./AddBankDetails";
import Loader from "../Common/Loader";
import { RootState } from "../../reducers";
import { FetchCustomerDetails } from "../../actions";

interface RemediationContainerProps {
  remediationDetails: RootState["pageData"]["remediationDetails"];
  customerLoaded: RootState["pageData"]["customerLoaded"];
  FetchCustomerDetails(): void;
}

let RemediationContainer = ({
  remediationDetails,
  customerLoaded,
  FetchCustomerDetails,
}: RemediationContainerProps) => {
  useEffect(() => {
    if (!customerLoaded) {
      FetchCustomerDetails();
    }
  }, []);

  const showRemediationContent = () => {
    return <AddBankDetails onSubmit={handleRemediationBankAccountUpdate} />;
  };

  if (!customerLoaded) {
    return <Loader />;
  }

  if (!remediationDetails?.isRemediationRequired) {
    return <Redirect to="/dashboard" />;
  }

  return (
    <SCPaymentSection>
      <Nav activePage="/bank-details" />
      <SCPaymentContent>
        <SCMakePaymentContainer>
          {showRemediationContent()}
        </SCMakePaymentContainer>
      </SCPaymentContent>
      <Footer />
    </SCPaymentSection>
  );
};

const mapStateToProps = (state: RootState) => ({
  remediationDetails: state.pageData.remediationDetails,
  customerLoaded: state.pageData.customerLoaded,
});

export default connect(mapStateToProps, { FetchCustomerDetails })(
  RemediationContainer
);
